import { z } from 'zod';

export const schemaJWT = z.object({
    exp: z.number(),
    id: z.string(),
    type: z.string(),
});
export type SchemaJWT = z.infer<typeof schemaJWT>;
